import React, { Component } from "react"; import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import axios from "axios";
import * as moment from "moment";
import {connect}  from  "react-redux";
var dMartClint = ["MAVE0001","MAVE0002","MAVE0004","MAVE0017","MAVE0018","MAVE0018","MAVE0020","MAVE0026","M00002","M00013","M00014","M00003","M00028","M00029","M00030","M00032","M00033","M00034","M00035","M00036","M00015","M00016","M00022","M00007","M00008","M00009","M00010","M00011","M00012","M00020","M00021","M00017","M00018","M00019","M00023","M00024","M00025","M00026","M00027"]
class Support extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray: [],
            acq_fall_last_updated: '',
            speed_last_updated: '',
            connectivity_last_updated: '',
            iss_speed_last_updated: '',
            acq_speed_last_updated: '',
            edc_health_last_updated: '',
            emi_sc_last_updated: '',
            object_code:[]
        }
    }
  componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if (permissionName.access_type == 'Submenu') {
                subMenuPermissions.push(permissionName.access_name);
            }
            if (permissionName.access_type == 'report') {
                reportPermissions.push(permissionName.access_name);
            }
        });
        if (subMenuPermissions.includes("support_module") === false) {
            this.unauthorize_access();
        }
        this.setState({
            reportPermissionsArray: reportPermissions,
            user_id: decoded._id,
            userType: decoded.userType,
            object_code: arrayCode,
        });
        this.get_last_update_acq_fall_back();
        this.get_last_update_speed_rel();
        this.get_last_update_connectivity();
        this.get_last_update_issuer_speed();
        this.get_last_update_acquirer_speed();
        this.get_last_update_edc_health();
        //this.get_last_update_emi_scheme();
    }
    unauthorize_access() {
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    get_last_update_acq_fall_back() {
        axios.get(config.get('API_URL') + '/reports/fall-back-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                acq_fall_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_speed_rel() {
        axios.get(config.get('API_URL') + '/reports/speed-reliability-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                speed_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_connectivity() {
        axios.get(config.get('API_URL') + '/reports/connectivity-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                connectivity_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_issuer_speed() {
        axios.get(config.get('API_URL') + '/reports/issuer-speed-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                iss_speed_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_acquirer_speed() {
        axios.get(config.get('API_URL') + '/reports/acquirer-speed-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                acq_speed_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_edc_health() {
        axios.get(config.get('API_URL') + '/reports/fall-back-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                edc_health_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_emi_scheme() {
        axios.get(config.get('API_URL') + '/reports/emi-scheme-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                emi_sc_last_updated: response.data[0].start_time
            })
        });
    }
    render() {

        return (

                    <div className="content-invoice">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 pt-5">
                                    <div className="">
                                        <div className="content">
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <div className="card title-card-bottom-space">
                                                        <div className="header">
                                                            <h4 className="title">Support Module</h4>
                                                            <p className="category"></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="content">
                                            <div className="row">
                                                {this.state.reportPermissionsArray.includes("acquirer_fallback") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/acquirer-fallback-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Acquirer Fallback Report</h5>
                                                                        <p className="text-muted">Last updated : {this.state.acq_fall_last_updated != '' ? moment(this.state.acq_fall_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("speed_and_reliability") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/speed-and-reliability-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Speed And Reliability Report</h5>
                                                                        <p className="text-muted">Last updated : {this.state.speed_last_updated != '' ? moment(this.state.speed_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("connectivity") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/connectivity-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Connectivity Report</h5>
                                                                        <p className="text-muted">Last updated : {this.state.connectivity_last_updated != '' ? moment(this.state.connectivity_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("issuer_speed") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/issuer-speed-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Issuer Speed Report</h5>
                                                                        <p className="text-muted">Last updated : {this.state.iss_speed_last_updated != '' ? moment(this.state.iss_speed_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}



                                            </div>
                                            <div className="row">
                                                {this.state.reportPermissionsArray.includes("acquirer_speed") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/acquirer-speed-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Acquirer Speed Report</h5>
                                                                        <p className="text-muted">Last updated : {this.state.acq_speed_last_updated != '' ? moment(this.state.acq_speed_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {/*{this.state.reportPermissionsArray.includes("edc_health") === true ?*/}
                                                {/*    <div className="col-lg-3 col-xs-6">*/}
                                                {/*        <div className="card report-dash">*/}
                                                {/*            <div className="content text-center">*/}
                                                {/*                <Link className="" to="/admin/edc-health-report/">*/}
                                                {/*                    <div className="report-thumbs-ico">*/}
                                                {/*                        <div className="icon-big text-center folder-icon">*/}
                                                {/*                            <i className="fa fa-folder-o"></i>*/}
                                                {/*                        </div>*/}
                                                {/*                        <h5>EDC Health Report</h5>*/}
                                                {/*                        <p className="text-muted">Last updated : {this.state.emi_sc_last_updated != '' ? moment(this.state.emi_sc_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>*/}
                                                {/*                    </div>*/}
                                                {/*                </Link>*/}
                                                {/*            </div>*/}
                                                {/*        </div>*/}
                                                {/*    </div> : null}*/}
                                                {/*{this.state.reportPermissionsArray.includes("user_login") === true ?*/}
                                                {/*    <div className="col-lg-3 col-xs-6">*/}
                                                {/*        <div className="card report-dash">*/}
                                                {/*            <div className="content text-center">*/}
                                                {/*                <Link className="" to="/admin/login-report/">*/}
                                                {/*                    <div className="report-thumbs-ico">*/}
                                                {/*                        <div className="icon-big text-center folder-icon">*/}
                                                {/*                            <i className="fa fa-folder-o"></i>*/}
                                                {/*                        </div>*/}
                                                {/*                        <h5>Login Report</h5>*/}
                                                {/*                        /!*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*!/*/}
                                                {/*                    </div>*/}
                                                {/*                </Link>*/}
                                                {/*            </div>*/}
                                                {/*        </div>*/}
                                                {/*    </div> : null}*/}
                                                {this.state.reportPermissionsArray.includes("emi_scheme") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/emi-scheme/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>EMI Scheme</h5>
                                                                        <p className="text-muted">Last updated : {this.state.emi_sc_last_updated != '' ? moment(this.state.emi_sc_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                {this.state.reportPermissionsArray.includes("echarge_slip_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/echargeslip-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>eChargeSlip Report</h5>

                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("bank_tid_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/bank-tid-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Bank TID Report</h5>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("utid_summary") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/utid-summary-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>UTID Summary </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("card_details") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/card-details-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Card Details Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("idle_tid") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/idle-tid-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Idle TID Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                    {this.state.reportPermissionsArray.includes("genie_margin_MTD") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/genie-margin-mtd-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>GENIE Margin MTD Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}


                                                {/*{this.state.reportPermissionsArray.includes("bounce_back_indicator_report") === true ?*/}
                                                {/*    <div className="col-lg-3 col-xs-6">*/}
                                                {/*        <div className="card report-dash">*/}
                                                {/*            <div className="content text-center">*/}
                                                {/*                <Link className="" to="/admin/bounce-back-indicator-report/">*/}
                                                {/*                    <div className="report-thumbs-ico">*/}
                                                {/*                        <div className="icon-big text-center folder-icon">*/}
                                                {/*                            <i className="fa fa-folder-o"></i>*/}
                                                {/*                        </div>*/}
                                                {/*                        <h5>Bounce Back Indicator Report</h5>*/}
                                                {/*                        /!*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*!/*/}
                                                {/*                    </div>*/}
                                                {/*                </Link>*/}
                                                {/*            </div>*/}
                                                {/*        </div>*/}
                                                {/*    </div> : null}*/}

                                                {/*{this.state.reportPermissionsArray.includes("bounce_back_indicator_report") === true ?*/}
                                                {/*    <div className="col-lg-3 col-xs-6">*/}
                                                {/*        <div className="card report-dash">*/}
                                                {/*            <div className="content text-center">*/}
                                                {/*                <Link className="" to="/admin/okr-report/">*/}
                                                {/*                    <div className="report-thumbs-ico">*/}
                                                {/*                        <div className="icon-big text-center folder-icon">*/}
                                                {/*                            <i className="fa fa-folder-o"></i>*/}
                                                {/*                        </div>*/}
                                                {/*                        <h5>OKR Report</h5>*/}
                                                {/*                        /!*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*!/*/}
                                                {/*                    </div>*/}
                                                {/*                </Link>*/}
                                                {/*            </div>*/}
                                                {/*        </div>*/}
                                                {/*    </div> : null}*/}

                                                {this.state.reportPermissionsArray.includes("genie_wallet_balance") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/genie-wallet-balance-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>GENIE wallet balance Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("stellr_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/stellr-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Stellr Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("unsupported_terminal_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/unsupported-terminal-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Unsupported Terminal Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                    {this.state.reportPermissionsArray.includes("bank_tid_report_geo") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/bank-tid-report-geo/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Geo Tagging Report</h5>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(Support);